import { CheckSSRActions } from "./store/check-ssr/check-ssr.slice";
import { ContentActions } from "./store/content/content.slice";
import { CurrentDateActions } from "./store/current-date/current-date.slice";
import { LanguagesAction } from "./store/languages/languageSlice";

import { collectServerSideState } from "./utils/helpers/collectServerSideState";

import "./i18n";

export const App = ({ routerProvider: RouterProvider, routerProps }) => {
  return <RouterProvider {...routerProps} />;
};

App.getServerSideState = async (store, params) => {
  if (params?.tag !== "article") {
    await collectServerSideState(store, params);
  }
  const state = store.getState();

  if (!state.checkSSR.isSSR) {
    store.dispatch(CheckSSRActions.setSSR());
  }

  store.dispatch(CurrentDateActions.setCurrentDate(new Date().toISOString()));

  store.dispatch(LanguagesAction.getLanguages());

  store.dispatch(ContentActions.getHTMLCode());
};
